import * as S from './styles'
import HomeIcon from '@mui/icons-material/Home'

const InitialPage = () => {
  const handleInitialPage = () => {
    window.location.href = '/'
  }

  return (
    <S.InitialPageStyled>
      <button onClick={handleInitialPage}><HomeIcon/></button>
    </S.InitialPageStyled>
  )
}

export default InitialPage
